import { createSlice } from '@reduxjs/toolkit';
import { UserState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getUserThunk } from './thunks';

// Initial State
const initialState: UserState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getUserThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getUserThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });

    builder.addCase(getUserThunk.rejected.type, (state, { payload }: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = userSlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default userSlice.reducer;
